import React from "react";

import { CircularProgress, Backdrop } from "@mui/material";

const Loader = () => (
  <Backdrop
    open={true}
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 9999 }}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default Loader;
